import { formatPercentage } from '@/features/report-snapshots/formatters/percentage';
import { formatRatio } from '@/features/report-snapshots/formatters/ratio';
import { PrimitiveType, FractionType } from '@/features/report-snapshots/interfaces';
import { formatSeconds } from '@/features/report-snapshots/formatters/duration';

export const formatValue = (
  value: PrimitiveType | FractionType,
  conversionUnit: string,
): string => {
  switch (conversionUnit) {
    case 'value': {
      throw new Error('Use useFormatters hook for formatting value units');
    }
    case 'seconds': {
      const duration = value as number;
      return formatSeconds(duration);
    }
    case 'text': {
      const text = value as string;
      return text;
    }
    case 'percent': {
      const fraction = value as FractionType;
      return formatPercentage({
        numerator: fraction.numerator.value,
        denominator: fraction.denominator.value,
      });
    }
    case 'ratio': {
      const fraction = value as FractionType;
      return formatRatio(fraction);
    }
    default:
      return formatValue(value, 'text');
  }
};
